import {
  accountsPath,
  accountPath,
} from './paths'
import { createLoadable } from './utility/utility'

const Accounts = createLoadable(() => import('./views/Accounts'))
const Account = createLoadable(() => import('./views/Accounts/Account/Account'))
const PortalGraphiQL = createLoadable(() => import('./views/PortalGraphiQL'))

// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routes = [
  { path: accountsPath, exact: true, name: 'Accounts', component: Accounts },
  { path: accountPath, exact: false, name: 'Account', component: Account },
  { path: '/graphiql', exact: true, name: 'GraphiQL', component: PortalGraphiQL },
];

export default routes